(ns practitest.frontend.milestone.charts
  (:require
   [re-frame.core :as re-frame]
   [practitest.frontend.common.i18n :refer [get-translation] :as i18n]
   [practitest.frontend.common.css-vars :as css-vars]
   [practitest.frontend.components.charts :as charts]
   [practitest.frontend.components2.spinners :as spinners]
   [practitest.frontend.components2.run-status :as run-status]
   [practitest.frontend.components2.issue-status :as issue-status]
   [practitest.frontend.components2.requirement-testing-status :as requirement-testing-status]
   [practitest.frontend.events :as events]
   [practitest.frontend.routing.router :as router]
   [practitest.frontend.subs :as subs]))

(defn graph-statuses->strings [graph-statuses]
  (map events/keyword->string graph-statuses))

(defn- client-status-color
  "Look up `status` in the DS-backed statuses-map for the given chart-key."
  [chart-key status]
  (case chart-key
    :coverage                        (requirement-testing-status/get-status-color status)
    (:execution :execution_progress) (run-status/get-status-color status)
    :issues                          (issue-status/get-status-color status)
    nil))

(defn- resolved-status-color
  "Resolve a status color, preferring the DS-backed map over the legacy backend-supplied one."
  [chart-key legacy-status-colors status]
  (css-vars/resolve-color
    (or (client-status-color chart-key status)
        (get legacy-status-colors status))))

(defn no-data-view []
  (get-translation "milestone.charts.no-data" "No data"))

(defn loading-view []
  [spinners/mux-spinner {:size :table}])

(defn chart-data [milestone chart-key]
  (some-> milestone
          :charts
          chart-key))

(defn main-page-chart [milestone chart-type title tab-key]
  (let [data (chart-data milestone chart-type)
        status-colors @(re-frame/subscribe [::subs/status-colors])]
    [:div.milestone-chart
     [:div.milestone-chart-title
      (get-translation (str "milestone." (name chart-type ) "-status.title") title)]
     [:div.milestone-chart-body
      [:a.undecorated-link
       {:href (router/get-href :practitest.frontend.milestones/edit
                               {:project-id   (:id @(re-frame/subscribe [::subs/current-project]))
                                :milestone-id (:id milestone)}
                               {}
                               {:tab tab-key})}
       (cond
         (nil? data)  (loading-view)
         (empty? data) (no-data-view)
         :else         (let [statuses              (keys data)
                             values                (vals data)
                             stringified-chart-keys (graph-statuses->strings statuses)]
                         [:div {:style {:width "220px"}}
                          [charts/mux-doughnut {:labels   stringified-chart-keys
                                                :datasets [{:label    title
                                                            :data      values
                                                            :bg-colors (map #(resolved-status-color chart-type status-colors %)
                                                                            stringified-chart-keys)}]
                                                :cutout   "90%"}]]))]]]))

(defn dashboard-pie-chart [milestone status-colors chart-key title]
  [:div.chart-container.pie-chart-container
   [:div.graph-title title]
   (let [data (chart-data milestone chart-key)
         statuses (keys data)
         stringified-chart-keys (graph-statuses->strings statuses)
         ds-colors (map #(resolved-status-color chart-key status-colors %) stringified-chart-keys)]
     [:div.chart-body
      (cond
        (nil? data)   (loading-view)
        (empty? data) (no-data-view)
        :else               [charts/pie
                             {:labels    stringified-chart-keys
                              :ds-data   (vals data)
                                 ; temp workaround to use any default colors until issues colors are defined 
                              :ds-colors (if (every? nil? ds-colors) (vals status-colors) ds-colors)
                              :display-legends? false}])])])

(defn dashboard-progress-chart [milestone status-colors chart-key title]
  (let [[series days] (chart-data milestone chart-key)
        raw-datasets (mapv (fn [{:keys [name data]}]
                             (let [color (resolved-status-color chart-key status-colors name)]
                               {:label name
                                :data data
                                :color color
                                :bg-color color}))
                           series)]
    [:div.progress-graph
     [:div.graph-title.text-nowrap (get-translation "milestones.dashboard.execution-progress.title"
                                                    title)]
     [:div.graph-data
      [charts/line-area-chart {:labels days
                               :datasets raw-datasets}]]]))
